// extracted by mini-css-extract-plugin
export default {"container":"OutOfState_container__NNO9C","title":"OutOfState_title__o7N+6","text":"OutOfState_text__L+wJx","email":"OutOfState_email__rsnlc"};